const requestTypesMap = {
  add: 'add',
  update: 'update',
  view: 'view',
}

export default requestTypesMap
